// extracted by mini-css-extract-plugin
export default {"Container":"ResultsMapping_Container__cVqcs","StepsWrapper":"ResultsMapping_StepsWrapper__LrGc0"};